<template>
  <nav class="toolbar">
    <div class="searchContainer">
      <IconButton
        v-if="showEnrollButton"
        class="buttonEnroll"
        :data-test-id="$testId('enrollButton')"
        icon="add"
        text="Enroll User Group"
        type="primary"
        @click="handleEnrollByUserGroup"
      />
      <InputSearch
        class="search"
        :data-test-id="$testId('inputSearch')"
        :focus="shouldFocusSearch"
        :placeholder="searchPlaceholder"
        :value="searchTerm"
        @input="triggerSearch"
      />
      <div class="refreshButtonWrapper">
        <IconButton
          v-if="showRefreshButton"
          ariaLabel="refresh"
          class="refreshButton"
          :data-test-id="$testId('refreshButton')"
          hasNoBackground
          icon="refresh"
          type="secondary"
          @click="handleRefresh"
        />
        <AnnouncementWrapper
          v-if="showRefreshButton"
          caretPosition="left"
          class="announcement"
          :header="$options.announcement.header"
          :localStorageKey="$options.announcement.localStorageKey"
          :mainActionText="$options.announcement.mainActionText"
          :text="$options.announcement.text"
          @main-action="handlePopoverMainAction"
        />
      </div>
    </div>
    <div class="actionsContainer">
      <Button
        v-if="showResendInvitationButton"
        :data-test-id="$testId('resendInvitationButton')"
        :isDisabled="isResendInvitationButtonDisabled || isResendInvitationButtonLoading"
        :isLoading="isResendInvitationButtonLoading"
        text="Resend Invitation Email"
        type="primary"
        @click="handleResendInvitationClick"
      />
    </div>
  </nav>
</template>

<script>
import {
  Button,
  IconButton,
  InputSearch,
} from '@jumpcloud/ui-components';
import {
  LocalStorageConsts,
} from 'client/util/Constants';
import AnnouncementWrapper from 'components/Announcement/AnnouncementWrapper.vue';

export default {
  name: 'PasswordManagerUsersItemListToolbar',

  components: {
    AnnouncementWrapper,
    Button,
    IconButton,
    InputSearch,
  },

  announcement: {
    header: 'List Refresh',
    localStorageKey: LocalStorageConsts.pwmUsersListRefreshAnnouncement,
    mainActionText: 'Refresh',
    text: 'Provisioning and deprovisioning users might take several minutes to get processed. You might need to hit the refresh button after enrolling or removing User Groups to see processed users.',
  },

  props: {
    isResendInvitationButtonDisabled: Boolean,

    isResendInvitationButtonLoading: Boolean,

    searchPlaceholder: {
      type: String,
      default: 'Search',
    },

    searchTerm: {
      type: String,
      default: '',
    },

    shouldFocusSearch: Boolean,

    showEnrollButton: Boolean,

    showRefreshButton: Boolean,

    showResendInvitationButton: Boolean,
  },

  methods: {
    handleEnrollByUserGroup() {
      this.$emit('enrollByUserGroupClick');
    },

    handlePopoverMainAction() {
      this.$emit('refreshTable');
    },

    handleRefresh() {
      this.$emit('refreshTable');
    },

    handleResendInvitationClick() {
      this.$emit('resendInvitation');
    },

    triggerSearch(value) {
      this.$emit('triggerSearch', value);
    },
  },
};
</script>

<style scoped>
  .actionsContainer {
    display: flex;
  }

  .announcement {
    left: -50px;
    top: 110%;
  }

  .buttonEnroll {
    margin-right: var(--jc-spacer);
  }

  .refreshButton {
    margin-left: var(--jc-spacer-x-small);
  }

  .refreshButtonWrapper {
    position: relative;
  }

  .search {
    flex: 0 1 35ch;
  }

  .searchContainer {
    display: flex;
    flex: 1;
  }

  .toolbar {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: var(--jc-spacer) 0 var(--jc-spacer);
  }
</style>
